import jquery from "jquery";
window.$ = jquery;

import "project_map/project_map_controller";
import "project_map/quick_edit";
import "asset_edit/edit_asset_controller";
import "asset_edit/submit_helper";

import "common/image_upload_preview";
import "common/barcode_decoder";

import "./asset/utilities";
